module.exports = __webpack_public_path__ + "static/Pallavi.cdcd5c12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mentImg/Pallavi.jpg
// module id = 243
// module chunks = 25111403944408 251948199435738